import { PUSH_HISTORY } from '../actionTypes'

export const pushHistory = (payload: object) => ({
  type: PUSH_HISTORY,
  payload,
})
